import React from 'react';
import { Link } from 'react-router-dom';
import { FiTruck, FiPackage, FiClock, FiGlobe, FiCheckCircle } from 'react-icons/fi';
import './Shipping.css';

const Shipping = () => {
  const shippingMethods = [
    {
      icon: <FiPackage />,
      name: 'Standard Shipping',
      time: '5-7 business days',
      price: '',
      cost: '$9.99'
    },
    {
      icon: <FiTruck />,
      name: 'Express Shipping',
      time: '2-3 business days',
      price: '',
      cost: '$19.99'
    },
    {
      icon: <FiClock />,
      name: 'Overnight Shipping',
      time: '1 business day',
      price: '',
      cost: '$34.99'
    },
    {
      icon: <FiGlobe />,
      name: 'International Shipping',
      time: '7-14 business days',
      price: 'Varies by location',
      cost: 'Calculated at checkout'
    }
  ];

  return (
    <div className="shipping-page">
      {/* Hero Section */}
      <section className="shipping-hero">
        <div className="container">
          <h1 className="shipping-hero-title">Shipping Policy</h1>
          <p className="shipping-hero-description">
            Fast, reliable shipping to over 50 countries worldwide.
          </p>
        </div>
      </section>

      {/* Shipping Methods */}
      <section className="shipping-methods-section">
        <div className="container">
          <h2 className="section-title">Shipping Methods & Rates</h2>
          <div className="methods-grid">
            {shippingMethods.map((method, index) => (
              <div key={index} className="method-card">
                <div className="method-icon">{method.icon}</div>
                <h3 className="method-name">{method.name}</h3>
                <p className="method-time">{method.time}</p>
                <p className="method-price">{method.cost}</p>
                {method.price && <p className="method-note">{method.price}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Shipping Details */}
      <section className="shipping-details">
        <div className="container">
          <div className="details-grid">
            <div className="details-content">
              <h2>Shipping Information</h2>
              
              <div className="detail-item">
                <h3>Processing Time</h3>
                <p>Orders are processed within 1-2 business days. You will receive a confirmation email once your order has been processed and shipped.</p>
              </div>

              <div className="detail-item">
                <h3>Tracking Your Order</h3>
                <p>Once your order ships, you will receive a tracking number via email. You can also track your order through your account or our <Link to="/track-order">Track Order</Link> page.</p>
              </div>

              <div className="detail-item">
                <h3>International Shipping</h3>
                <p>We ship to over 50 countries worldwide. International orders may be subject to import duties and taxes, which are the responsibility of the customer.</p>
              </div>

              <div className="detail-item">
                <h3>Shipping Restrictions</h3>
                <p>We currently do not ship to P.O. boxes or APO/FPO addresses. Some items may have shipping restrictions based on size or destination.</p>
              </div>
            </div>

            <div className="details-highlight">
              <div className="highlight-box">
                <FiCheckCircle className="highlight-icon" />
                <h3>Free Returns</h3>
                <p>30-day return policy for unworn items</p>
                <Link to="/returns" className="highlight-link">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="shipping-faq">
        <div className="container">
          <h2 className="section-title">Shipping FAQ</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>When will my order ship?</h3>
              <p>Orders typically ship within 1-2 business days after processing. You'll receive a shipping confirmation email with tracking information once your order has shipped.</p>
            </div>
            <div className="faq-item">
              <h3>Can I change my shipping address?</h3>
              <p>Address changes can be made within 2 hours of placing your order. Please contact our customer service team immediately if you need to update your shipping address.</p>
            </div>
            <div className="faq-item">
              <h3>Do you ship internationally?</h3>
              <p>Yes, we ship to over 50 countries. Shipping costs and delivery times will be calculated at checkout based on your location.</p>
            </div>
            <div className="faq-item">
              <h3>What if my package is lost or stolen?</h3>
              <p>If your tracking shows delivered but you haven't received your package, please contact us immediately. We'll work with the carrier to resolve the issue.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Support */}
      <section className="shipping-support">
        <div className="container">
          <div className="support-box">
            <h2>Need Help With Your Order?</h2>
            <p>Our customer service team is here to assist you with any shipping questions or concerns.</p>
            <div className="support-buttons">
              <Link to="/contact" className="support-btn primary">CONTACT US</Link>
              <Link to="/track-order" className="support-btn secondary">TRACK ORDER</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Shipping;